import { ISPaywallCoupon } from '@invoice-simple/is-coupon';

export const CANCEL_PROMO_COUPON: ISPaywallCoupon = 'cancelPromo50off3months';
